import { render, staticRenderFns } from "./PostsSearch.vue?vue&type=template&id=d889314e&scoped=true&"
import script from "./PostsSearch.vue?vue&type=script&lang=ts&"
export * from "./PostsSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PostsSearch.vue?vue&type=style&index=0&id=d889314e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d889314e",
  null
  
)

export default component.exports